export const theme = {
	palette: {
		primary: {
			light: "#c8d6ce",
			main: "#9CB0A5",
			dark: "#66736C"
		},
		secondary: {
			light: "#c8d6ce",
			main: "#B88451",
			dark: "#66736C"
		},
		background: {
			footer: "#3C3C3C",
			button: "#B88451",
			buttonHover: "#7BB093",
			menuMobileBackdropLayer1: "#9CB0A5",
			menuMobileBackdropLayer2: "#E5E5E3",
			menuMobileBackdropLayer3: "#FFFFFF"
		},
		bodyText: "#DBDBDB",
		link: {
			primary: "#7BB093",
			secondary: "#D1965C"
		}
	},
	typography: {
		fontFamily: "'Rum-Sans', sans-serif",
		fontWeightLight: 300,
		fontWeightRegular: 300,
		fontWeightMedium: 500,
		fontWeightBold: 700,
		body1: {
			fontFamily: "'Rum-Sans'",
			fontSize: 18,
			fontWeight: 300,
			lineHeight: 1.77
		},
		body2: {
			fontFamily: "'Rum-Sans'",
			fontSize: 16,
			fontWeight: 300,
			lineHeight: 1.5
		},
		h1: {
			color: "#3C3C3C !important",
			fontFamily: "'Rum-Serif'",
			fontSize: "clamp(42px, 8vw, 64px)",
			fontWeight: 600,
			hyphens: "auto",
			textAlign: "center"
		},
		h2: {
			color: "#3C3C3C !important",
			fontFamily: "'Rum-Serif'",
			fontSize: "clamp(36px, 8vw, 42px)",
			fontWeight: 600,
			hyphens: "auto",
			textAlign: "center"
		},
		h3: {
			color: "#3C3C3C !important",
			fontFamily: "'Rum-Serif'",
			fontSize: "clamp(36px, 8vw, 36px)",
			fontWeight: 600,
			hyphens: "auto",
			textAlign: "left"
		},
		h4: {
			color: "#3C3C3C !important",
			fontFamily: "'Rum-Serif'",
			textAlign: "left"
		},
		h5: {
			color: "#3C3C3C !important",
			fontFamily: "'Rum-Serif'",
			textAlign: "left"
		},
		h6: {
			fontFamily: "'Rum-Serif'",
			fontSize: 18,
			fontWeight: 600,
			letterSpacing: "0.05em",
			textAlign: "left"
		},
		button: {
			fontFamily: "'Rum-Serif'",
			fontSize: 18,
			fontWeight: 600,
			letterSpacing: "0.05em",
			textTransform: "none"
		},
		smallText: {
			fontSize: 14
		}
	},
	shape: {
		borderRadius: 0
	},
	overrides: {
		MuiCssBaseline: {
			"@global": {
				html: {
					"--palette-primary-main": "#7BB093",
					"--palette-secondary-main": "#B88451"
				}
			}
		},
		MuiButton: {
			root: {
				boxShadow: "none !important",
				height: 45
			},
			sizeSmall: {
				height: 32
			},
			sizeLarge: {
				height: 50
			}
		}
	},
	customTypography: {
		mainmenu: {
			mobile: {
				level1: {
					color: "black",
					fontFamily: "'Rum-Serif'",
					fontWeight: 600,
					fontSize: 22
				},
				level2: {
					fontFamily: "'Rum-Serif'",
					fontWeight: 600,
					fontSize: 18
				},
				level3: {
					fontWeight: 300,
					fontSize: 16
				}
			},
			desktop: {
				level1: {
					fontSize: 14,
					fontWeight: 700
				},
				level2: {
					fontSize: 16
				},
				level3: {
					fontSize: 14
				}
			}
		}
	}
};
